module.exports = __webpack_public_path__ + "assets/img/slogan-6cf073c6.png";